import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { RestaurantsSlice } from '.'
import { RestaurantsStatusSlice } from './statusSlice'
import { AppDispatch } from '../../index'
import { IFetchRestaurants, IRestaurant } from './types'

export const getRestaurants =
  (params: IFetchRestaurants) => async (dispatch: AppDispatch) => {
    // Reset on every dispatch, not just the first — a company switch
    // (Welcome/GUIDPicker) re-fetches restaurants for a different company,
    // and without this the banner would keep showing the previous company's
    // address as "settled" until the new response lands.
    dispatch(RestaurantsStatusSlice.actions.restaurantsRequested())
    try {
      const restaurants: IRestaurant[] = await qrMenuGET.restaurants(
        params.ActiveBranchID
      )
      dispatch(RestaurantsSlice.actions.setRestaurants(restaurants))
    } catch (e) {
      console.log('restaurants request failure')
    } finally {
      dispatch(RestaurantsStatusSlice.actions.restaurantsSettled())
    }
  }
